import { useCallback, useLayoutEffect } from 'react';

import { CenterFlex } from '@/components/base';
import Spinner from '@/components/Common/Spinner';
import useWorkspaceRouter from '@/hooks/domain/useWorkspaceRouter';
import service from '@/services';
import { useWorkspaceCacheStoreAction } from '@/stores/WorkspaceCacheStore';

const Dashboard2IndexPage = () => {
  const { cache } = useWorkspaceCacheStoreAction();
  const recentDashboardHistory = cache.recentDashboardHistory;

  const wr = useWorkspaceRouter();

  const routingCallback = useCallback(async () => {
    const lastViewed = recentDashboardHistory[0];
    try {
      const res = await service.dashboard2.fetchDashboard(lastViewed);
      if (res.alias) {
        wr.push(`/dashboard2/${res.alias}`, {
          replace: true,
          relative: 'route',
        });
        return;
      }
    } catch (e) {
      console.error(e);
    }

    const data = await service.dashboard2.fetchDashboardList({
      sort_by: 'updated_at',
      order_by: 'desc',
      limit: 3,
    });

    const lastUpdated = data?.dashboards?.[0];
    if (lastUpdated) {
      wr.push(`/dashboard2/${lastUpdated.alias}`, {
        replace: true,
        relative: 'route',
      });
      return;
    }

    wr.push(`/dashboard2/list`, {
      replace: true,
      relative: 'route',
    });
  }, [wr, recentDashboardHistory]);

  useLayoutEffect(() => {
    routingCallback();
  }, [routingCallback]);

  return (
    <CenterFlex height="100%">
      <Spinner />
    </CenterFlex>
  );
};

export default Dashboard2IndexPage;
